import React from 'react';

const PurchaseReportPage = React.lazy(() => import('pages/PurchaseReport/PurchaseReportPage'));

const purchaseReportRoute = [
  {
    path: '/purchase-report',
    exact: true,
    name: 'Báo cáo mua hàng',
    function: 'SL_PURCHASEORDER_VIEW',
    component: PurchaseReportPage,
  },
];

export default purchaseReportRoute;
